import CONFIG from "../../config";

let resizeObserver = null;
if (window.ResizeObserver && window.OSPlusNeo) {
  // resizeObserver available

  const OSPlusResizeHandler = () => {
    if (typeof window.OSPlusNeo.setHeight !== "function") return;
    const root = document.getElementById(CONFIG.SHOP_ID);
    const container = document.getElementById("rechner_SE_SHOP");
    if (root) {
      const height = root.getBoundingClientRect().height;
      window.OSPlusNeo.setHeight(height);
    } else if (container) {
      const height = container.getBoundingClientRect().height;
      window.OSPlusNeo.setHeight(height);
    }
  };

  const setScrollClass = (scrollY) => {
    const body = document.querySelector('body');
    if (body) {
      if (scrollY > 120) {
        body.classList.add("minimizeBasket");
      } else {
        body.classList.remove("minimizeBasket");
      }
      body.dataset.scroll = scrollY;
    }
  }
  const observerCallback = (entries) => {
    window.requestAnimationFrame(() => {
      if (!Array.isArray(entries) || !entries.length) {
        return;
      }
      OSPlusResizeHandler();
    });
  };
  resizeObserver = new ResizeObserver(observerCallback);

  if (typeof window.OSPlusNeo.setScrollListener === "function") {
    window.OSPlusNeo.setScrollListener((pos) => {
      if (pos && !isNaN(pos.scrollTop)) window.scrollY = pos.scrollTop;
      setScrollClass(window.scrollY)
    });
  }
  window.onscrollend = (e) => {
    const scrollY = e && e.view ? e.view.scrollY : 0;
    setScrollClass(scrollY)
    console.log(e);
  }
}

export function checkResize() {
  if (
    window.OSPlusNeo &&
    typeof window.OSPlusNeo.setHeight === "function" &&
    window.top &&
    window.top.document &&
    window.top.document.querySelector('iframe')
  ) {
    const root = document.getElementById(CONFIG.SHOP_ID);
    if (root && resizeObserver) {
      const body = document.getElementsByTagName("body");
      if (body && body.length) {
        body[0].style.overflow = "hidden";
        window.OSPlusNeo.setHeight(body[0].getBoundingClientRect().height);
      }
      resizeObserver.disconnect();
      resizeObserver.observe(root);
    } else {
      const body = document.getElementsByTagName("body");
      if (body && body.length) {
        body[0].style.overflow = "auto";
      }
    }
  }
};
